import { cn } from "@workspace/ui/lib/utils";
import type React from "react";

export type FeatureItem = {
  title: string;
  description: string;
  icon: React.ReactNode;
};

export const Feature = ({
  title,
  description,
  icon,
  index,
  totalFeatures,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  index: number;
  totalFeatures: number;
}) => {
  const isTopRow = index < 3;
  const isLeftColumn = index % 3 === 0;
  const isRightColumn = index % 3 === 2;

  return (
    <div
      className={cn(
        "group/feature relative flex flex-col py-6 md:py-10 dark:border-neutral-800",
        !isRightColumn && "lg:border-r",
        isLeftColumn && "lg:border-l dark:border-neutral-800",
        isTopRow && totalFeatures > 3 && "lg:border-b dark:border-neutral-800"
      )}
    >
      {isTopRow && totalFeatures > 3 && (
        <div className="pointer-events-none absolute inset-0 h-full w-full bg-linear-to-t from-neutral-100 to-transparent opacity-0 transition duration-200 group-hover/feature:opacity-100 dark:from-neutral-800" />
      )}
      {!isTopRow && (
        <div className="pointer-events-none absolute inset-0 h-full w-full bg-linear-to-b from-neutral-100 to-transparent opacity-0 transition duration-200 group-hover/feature:opacity-100 dark:from-neutral-800" />
      )}
      <div className="relative z-10 mb-3 px-6 text-neutral-600 md:mb-4 md:px-10 dark:text-neutral-400">
        {icon}
      </div>
      <div className="relative z-10 mb-2 px-6 font-bold text-base md:px-10 md:text-lg">
        <div className="absolute inset-y-0 left-0 h-5 w-1 origin-center rounded-tr-full rounded-br-full bg-neutral-300 transition-all duration-200 group-hover/feature:h-7 group-hover/feature:bg-blue-500 md:h-6 md:group-hover/feature:h-8 dark:bg-neutral-700" />
        <span className="inline-block text-neutral-800 transition duration-200 group-hover/feature:translate-x-2 dark:text-neutral-100">
          {title}
        </span>
      </div>
      <p className="relative z-10 max-w-xs px-6 text-neutral-600 text-xs md:px-10 md:text-sm dark:text-neutral-300">
        {description}
      </p>
    </div>
  );
};
